<template>
  <div>

    <!-- 调用树形下拉框组件 -->
    <SelectTree
      ref="selectTree"
      :props="props"
      :options="data"
      :value="valueId"
      :clearable="isClearable"
      :accordion="isAccordion"
      @change="handleChange"
      @filter-method="handleSearch"
    />
  </div>
</template>

<script>
  import SelectTree from "./index2.vue";
  import {getCascade} from "@/services/deviceType";

  export default {
    name: "MultipleTreeOperator",
    components: {
      SelectTree
    },
    watch: {
      value: {
        immediate: true,
        handler(value) {
          if (value) {
            value = value.filter(item => {
              return item
            })
          }
          if (value && value.length != 0) {
            this.valueId = value;
          } else {
            this.valueId = [];
          }
          this.setCheckList();
        }
      }
    },
    props: {
      value: {},
        type:{
            default(){
                return undefined;
            }
        },
    },
    data() {
      return {
        data: [],
        isClearable: true,      // 可清空（可选）
        isAccordion: true,      // 可收起（可选）
        valueId: 0,            // 初始ID（可选）
        props: {                // 配置项（必选）
          value: 'id',
          label: 'operatorName',
          children: 'children',
          // disabled:true
        },
        // 选项列表（必选）
        list: []
      };
    },

    methods: {
      handleSearch(data) {
        this.data = this.oriData.filter(item => {
          return item.operatorName.indexOf(data) != -1;
        })
      },
      setCheckList() {
        this.$nextTick(() => {
          if (this.valueId && this.operator) {
            let checkList = this.operator.filter(item => {
              return this.valueId.find(item2 => {
                return item2 == item.value
              })
            });
          this.$refs.selectTree && this.$refs.selectTree.setCheckList(checkList.map(item => {
                        return item.name;
                      }))
          }
        })

      },
      // // 取值
      // getValue(value){
      //     this.valueId = value
      //     let find = this.operator.find((item, i) => {
      //         return item.value == value
      //     })
      //     if (!find) {
      //         find = {};
      //     }
      //
      //     if (find==undefined) {
      //         find = "";
      //     }
      //     this.$emit("input", {...find});
      //     this.$emit("change", {...find});
      //    // this.data = {...find};
      // },

      handleChange(value) {

          let oriList=this.valueId.map(item=>{
              return Number.parseInt(item);
          })

          if(oriList.length<value.length){
            let addList=  value.filter(item=>{
                  return !oriList.includes(item)
              });
              this.$emit("add", {items:addList,list:value});
          }

          if(oriList.length>value.length){
              let subList=  oriList.filter(item=>{
                  return !value.find(item2=>{
                      return item2==item;
                  })
              });
              this.$emit("sub",  {items:subList,list:value});
          }
          // console.log(this.valueId,value)
          // debugger
        this.$emit("input", value);
        this.$emit("change", value);
        //  this.data = value;
      },


      getOperatorIds(list) {
        let result = [];
        for (let i = 0; i < list.length; i++) {
          result.push(list[i].id);
          if (list[i].children) {
            let ids = this.getOperatorIds(list[i].children);
            if (ids) {
              result = [...result, ...ids];
            }
          }
        }
        return result;
      },


      getSurplusItem(ids, list) {
        return list.filter(item => {
          return !ids.find(item2 => {
            return item2 == item.id;
          });
        });
      },

      async loadData() {
        const response = await getCascade({type:this.type});

        if (response) {

          let list = [...response.data.operatorName];

          let totalData = []
          while (list.length > 0) {
            let operator = list.sort((a, b) => {
              return a.level.localeCompare(b.level)
            });
            let data = operator.filter(father => {                      // 循环所有项，并添加children属性
              let branchArr = operator.filter(child => father.id == child.parentId);       // 返回每一项的子级数组
              branchArr.length > 0 ? father.children = branchArr : ''   //给父级添加一个children属性，并赋值
              return father.level == operator[0].level;      //返回第一层
            });
            totalData = [...totalData, ...data];

            let ids = this.getOperatorIds(data);
            list = this.getSurplusItem(ids, list);
          }


          this.data = totalData;
          this.oriData = totalData;
          this.operator = response.data.operatorName.map((item, i) => {
            return {name: item.operatorName, value: item.id}
          });

        }
        this.setCheckList();
      },
    },
    created() {
      this.loadData();
    }
  };
</script>

<style>
  /*#app {*/
  /*  font-family: "Avenir", Helvetica, Arial, sans-serif;*/
  /*  -webkit-font-smoothing: antialiased;*/
  /*  -moz-osx-font-smoothing: grayscale;*/
  /*  text-align: center;*/
  /*  color: #2c3e50;*/
  /*  margin-top: 60px;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/TreeSelect/MultipleTreeOperator.vue